package com.shadowings.gero.presentation.component.avatars

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.UserData
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun InteractiveAvatar(
    character: Characters = Characters.Alyn,
    userData: UserData = UserData(),
    baseFace: Faces = Faces.Idle,
    modifier: Modifier = Modifier,
    withBackground: Boolean = false,
) {
    var isSurprised by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    var revertJob by remember { mutableStateOf<Job?>(null) }
    val hapticFeedback = LocalHapticFeedback.current

    val scale by animateFloatAsState(
        targetValue = if (isSurprised) 1.12f else 1f,
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessLow
        )
    )

    val currentFace = if (isSurprised) Faces.Surprised else baseFace

    val avatarModifier = modifier
        .graphicsLayer {
            scaleX = scale
            scaleY = scale
        }
        .clickable(
            interactionSource = remember { MutableInteractionSource() },
            indication = null
        ) {
            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
            isSurprised = true
            revertJob?.cancel()
            revertJob = scope.launch {
                delay(500)
                isSurprised = false
            }
        }

    when (character) {
        Characters.Nilo -> NiloAvatar(
            userData = userData,
            face = currentFace,
            withBackground = withBackground,
            modifier = avatarModifier
        )
        Characters.Zeta -> ZetaAvatar(
            userData = userData,
            face = currentFace,
            withBackground = withBackground,
            modifier = avatarModifier
        )
        Characters.Masko -> MaskoAvatar(
            userData = userData,
            face = currentFace,
            withBackground = withBackground,
            modifier = avatarModifier
        )
        Characters.Alyn -> AlynAvatar(
            userData = userData,
            face = currentFace,
            withBackground = withBackground,
            modifier = avatarModifier
        )
    }
}
